/**
 *-------------------------------------------
 * create filter info actions in redux
 *-------------------------------------------
 */

export const getFilter = () => {
    return {
        type: 'GET_FILTER'
    }
}

export const updateFilter = (filter) => {
    return {
        type: 'UPDATE_FILTER',
        filter
    }
}

export const clearFilter = (filter) => {
    return {
        type: 'CLEAR_FILTER',
        filter
    }
}
